module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.changeversion')))]), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('div', {
    staticClass: "tab-contents",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('table', {
    staticClass: "datatable"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_vm._v(_vm._s(log.version))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.htmlNow(log.description))
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.by_user))])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Версия")]), _vm._v(" "), _c('th', [_vm._v("Описание")]), _vm._v(" "), _c('th', [_vm._v("Дата")]), _vm._v(" "), _c('th', [_vm._v("Кто сделал")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21921f86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/ChangeVersion.vue
// module id = 527
// module chunks = 0